import { watchUserPosition, stopWatchingUserPosition } from '@/project/components/map/uitls/helpers.js'
import updateLocation from '../fetches/updateLocation.js'
import Storage from '@/shared/utils/storage'

class PositionSyncService {
  constructor() {
    this.watchId = null
    this.lastSyncTime = 0
    this.syncInterval = 30000 // 30 seconds
    this.isSyncing = false
  }

  async start() {
    if (this.isSyncing) return
    
    console.log('[PositionSyncService] Starting tracking...')
    this.isSyncing = true

    try {
      this.watchId = watchUserPosition(async (pos) => {
        await this.handlePositionUpdate(pos)
      }, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      })
    } catch (error) {
      console.error('[PositionSyncService] Failed to start watch:', error.message)
      this.isSyncing = false
    }
  }

  stop() {
    if (!this.isSyncing) return
    
    console.log('[PositionSyncService] Stopping tracking...')
    if (this.watchId) {
      stopWatchingUserPosition(this.watchId)
      this.watchId = null
    }
    this.isSyncing = false
  }

  async handlePositionUpdate(pos) {
    const now = Date.now()
    
    // Only sync if enough time has passed
    if (now - this.lastSyncTime < this.syncInterval) {
      return
    }

    // Only sync if rider is online
    const userData = Storage.get('userData')
    if (userData?.status !== 'online') {
      return
    }

    this.lastSyncTime = now
    
    try {
      console.log('[PositionSyncService] Syncing position to server:', pos.lat, pos.lng)
      await updateLocation.execute({
        latitude: pos.lat,
        longitude: pos.lng
      })
    } catch (error) {
      console.error('[PositionSyncService] Sync failed:', error.message)
    }
  }
}

export default new PositionSyncService()
